export const DEFAULT_CONTRACT = 'default';
export const PARNASSE_CONTRACT = 'parnasse';
export const PROTECTED_HOUSE_CONTRACT = 'maison_protegee';
export const PROTECTED_HOUSE_CONTRACT_2 = 'maison_protegee_2';
export const ORANGE_BUSINESS_CONTRACT = 'obs';
export const ORANGE_PRO_CONTRACT = 'pro';
export const OPEN_CARAIBE = 'open_caraibe';
export const MOBICARTE = 'carte_prepayee';
export const FIXE = 'fixe';
